module.exports = __webpack_public_path__ + "static/media/slide-coupon-white.2f005015.svg";